/**
 * 批次属性组件 - 用于展示溯源系统中的批次信息卡片
 * 
 * 组件类型标识：type == 22
 * 
 * @component
 * @props {Object} componentsData - 组件配置数据
 * @props {number} componentsData.type - 组件类型，固定为 22（批次属性）
 * @props {Object} componentsData.content - 组件内容配置
 * 
 * 版本控制属性（version 为 true 时生效）：
 * @props {string} componentsData.content.bg_color - 背景颜色
 * @props {Object} componentsData.content.bg_img - 背景图片对象，picview 为图片预览地址
 * @props {boolean} componentsData.content.bg_value - 是否启用背景图片
 * @props {Object} componentsData.content.paddingData - 内边距，{ top, left }
 * @props {Object} componentsData.content.marginData - 外边距，{ top, left }
 * @props {Object} componentsData.content.radiusData - 圆角，{ top, bottom }
 * 
 * 旧版属性（version 为 false/undefined 时生效）：
 * @props {Object} componentsData.content.marginData - 边距，{ top, left, topRadius, bottomRadius }
 * @props {string} componentsData.content.bg_color - 背景颜色
 * 
 * 标题栏属性：
 * @props {number} componentsData.content.style_value - 标题样式，1 为居中带装饰线，其他为对齐文本
 * @props {string} componentsData.content.headline - 标题文本
 * @props {string} componentsData.content.headline_color - 标题文字颜色
 * @props {number} componentsData.content.headline_size - 标题文字大小（px）
 * @props {string} componentsData.content.headline_bg_color - 标题栏背景颜色
 * @props {string} componentsData.content.headline_border_color - 标题栏底部分割线颜色
 * @props {string} componentsData.content.headline_position - 标题文本对齐方式（style_value 非 1 时生效）
 * @props {string} componentsData.content.dec_color - 标题装饰线渐变颜色
 * 
 * 内容区属性：
 * @props {string} componentsData.content.title - 内容标题文本
 * @props {string} componentsData.content.title_color - 内容标题颜色
 * @props {number} componentsData.content.title_size - 内容标题大小（px）
 * @props {string} componentsData.content.text_name_color - 批次名称标签颜色
 * @props {number} componentsData.content.text_name_size - 批次名称标签大小（px）
 * @props {string} componentsData.content.text_color - 批次内容文本颜色
 * @props {number} componentsData.content.text_size - 批次内容文本大小（px）
 * @props {boolean} componentsData.content.version - 版本标识，true 为新版数据结构，false/undefined 为旧版
 */
<!-- 批次属性 -->
<template>
    <div v-if="componentsData.type == 22">
        <div
            class="overflow-hidden bg-div"
            :style="
                componentsData.content.version
                    ? {
                          ...(componentsData.content.bg_color && {
                              backgroundColor: componentsData.content.bg_color,
                          }),
                          ...(componentsData.content.bg_img.picview &&
                              componentsData.content.bg_value && {
                                  backgroundImage: `url(${componentsData.content.bg_img.picview})`,
                              }),
                          padding: `${componentsData.content.paddingData.top}px ${componentsData.content.paddingData.left}px`,
                          margin: `${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px`,
                          borderRadius: `${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.bottom}px ${componentsData.content.radiusData.bottom}px`,
                      }
                    : `padding: ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px;background: ${componentsData.content.bg_color};border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px`
            "
        >
            <div
                class="flex-c header-pb"
                v-if="componentsData.content.style_value == 1"
                :style="`border-bottom: 1px solid ${componentsData.content.headline_border_color};
                    background: ${componentsData.content.headline_bg_color}; font-size: ${componentsData.content.headline_size}px; color: ${componentsData.content.headline_color};
                `"
            >
                <div class="dec-left" :style="{ background: decLeft }"></div>
                <div class="dec-content fw-bold">
                    {{ componentsData.content.headline }}
                </div>
                <div class="dec-right" :style="{ background: decRight }"></div>
            </div>
            <div
                v-else
                class="header-pb fw-bold"
                :style="`text-align: ${componentsData.content.headline_position};border-bottom: 1px solid ${componentsData.content.headline_border_color};
                    background: ${componentsData.content.headline_bg_color}; font-size: ${componentsData.content.headline_size}px; color: ${componentsData.content.headline_color};
                `"
            >
                {{ componentsData.content.headline }}
            </div>
            <div class="pt-6">
                <div
                    :style="`font-size: ${componentsData.content.title_size}px; color: ${componentsData.content.title_color};`"
                >
                    内容标题
                </div>
                <div class="txt-div">
                    <div
                        :style="`color: ${componentsData.content.text_name_color};font-size: ${componentsData.content.text_name_size}px;`"
                    >
                        批次名称：
                    </div>
                    <div
                        :style="`color: ${componentsData.content.text_color};font-size: ${componentsData.content.text_size}px;`"
                    >
                        批次内容
                    </div>
                </div>
                <div class="txt-div">
                    <div
                        :style="`color: ${componentsData.content.text_name_color};font-size: ${componentsData.content.text_name_size}px;`"
                    >
                        批次名称：
                    </div>
                    <div
                        :style="`color: ${componentsData.content.text_color};font-size: ${componentsData.content.text_size}px;`"
                    >
                        批次内容
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: () => ({}),
            required: true,
        },
    },
    computed: {
        decLeft() {
            const color = this.componentsData.content?.dec_color || "#000";
            return `linear-gradient(to left, ${color}, transparent)`;
        },
        decRight() {
            const color = this.componentsData.content?.dec_color || "#000";
            return `linear-gradient(to right, ${color}, transparent)`;
        },
    },
};
</script>

<style scoped>
.overflow-hidden {
    overflow: hidden;
}
.form-container {
    margin: 0 24px;
}
.text-container {
    padding: 0 12px 12px 12px;
    background-color: hsla(0, 0%, 88.2%, 0.67) !important;
}
.text-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 0;
    border-bottom: 1px solid rgb(0, 159, 194);
}
.dec-left {
    margin: 0 12px;
    width: 50px;
    height: 4px;
    border-radius: 2px;
}
.dec-right {
    margin: 0 12px;
    width: 50px;
    height: 4px;
    border-radius: 2px;
}
.dec-content {
    max-width: 200px;
    white-space: nowrap; /* 确保文本不会换行 */
    overflow: hidden; /* 隐藏溢出的文本 */
    text-overflow: ellipsis; /* 显示省略号来代表被修剪的文本 */
}
.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.header-pb {
    padding-bottom: 6px;
}
.pt-6 {
    padding-top: 6px;
}
.txt-div {
    padding: 6px 0 0 0;
    display: flex;
}
.fw-bold {
    font-weight: bold;
}
</style>